import { db, Timestamp } from "@/utils/Firebase";
import moment from 'moment-timezone'

export const createNotification = async (payload) => {
    const timeZone = moment.tz.guess()
    const fullDate = `${payload.date}T${payload.hour}:00`
    const localMoment = moment.tz(fullDate, timeZone)
    const notificationPayload = {
        ...payload,
        createdAt: Timestamp.now(),
        sent: false,
        timezone: timeZone,
        dateTime: localMoment.format(),
        dateTimeUTC: localMoment.utc().format(),
    }
    return await db.collection('notificationsPending').add(notificationPayload)
}

export const updateNotification = async (notificationId, payload) => {
    const timeZone = moment.tz.guess()
    const fullDate = `${payload.date}T${payload.hour}:00`
    const localMoment = moment.tz(fullDate, timeZone)
    const notificationPayload = {
        ...payload,
        timezone: timeZone,
        dateTime: localMoment.format(),
        dateTimeUTC: localMoment.utc().format(),
    }
    await db.collection('notificationsPending').doc(notificationId).update(notificationPayload)
}

export const deleteNotification = async (notificationId) => {
    await db.collection('notificationsPending').doc(notificationId).delete()
}